import React from "react";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { Details, LeadHeader } from "./components";
import "../../styles/details.scss";
import api from "../../api";
import { useLead, useConfiguration, AppPermissions, useHasPermission } from "../../core";
import { ContainerLoader } from "../../components/loader";
import { State } from "../../core/store/interfaces";
import { RouteKeys } from "../routes/route-keys";
import { ConfirmationDialogProvider } from "../../core/components/confirm-popup/confirm-popup";
import Requirement from "../requirement";

const LeadDetails: React.FunctionComponent<{
  onClose?: () => void;
  id?: string;
  leadCreated: () => void;
}> = (props) => {
  const history = useHistory();
  const leadState = useSelector((state: State) => state.lead);
  const params = useParams<{ id?: string }>();
  const { getLead, clearData } = useLead(api.lead);

  const { modalOpen: requirementModalOpen } = useConfiguration(api);
  const canArchivedLeads = useHasPermission(AppPermissions.canArchivedLeads);

  React.useEffect(() => {
    if (params.id) {
      getLead(params.id);
      updateSearchView(params.id);
    } else {
      clearData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const updateSearchView = async (id: string) => {
    try {
      const response = await api.globalSearch.updateSearchView(id, "Lead");
    } catch (error) {
      // console
    }
  };

  const onClose = () => {
    history.goBack();
  };

  const isForCurrentRoute = leadState.leadDetails?._id === params.id;

  if (leadState.isDetailsLoading || !isForCurrentRoute) {
    return (
      <>
        <div className="detail-poupup lead-detail bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
          <ContainerLoader></ContainerLoader>
        </div>
      </>
    );
  }

  return leadState.leadDetails ? (
    <ConfirmationDialogProvider>
      <div className="detail-poupup lead-detail bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <LeadHeader
          showArchiveButton={canArchivedLeads}
          onClose={onClose}
          onReload={() => {
            getLead(leadState?.leadDetails?._id!);
          }}
        ></LeadHeader>
        <Details onReload={() => getLead(params.id)}></Details>
      </div>
      {requirementModalOpen && (
        <Requirement
          leads={[leadState.leadDetails]}
          customer={leadState.leadDetails?.customer}
          reload={() => {
            getLead(leadState?.leadDetails?._id!);
          }}
        ></Requirement>
      )}
    </ConfirmationDialogProvider>
  ) : (
    <></>
  );
};

export default LeadDetails;
